module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point04_01_activity-2e98c33d3055026734620fcc42bd8681.jpg";